<ngx-spinner class="custom-spinner"  bdColor="none"
size="default" color="#bb07f7" type="ball-clip-rotate"></ngx-spinner>
<!-- <ngx-spinner class="custom-spinner"   bdColor="none"
 size="default" color="#f00707" type="ball-clip-rotate" [name]="'msgspinner'"></ngx-spinner> -->

<router-outlet></router-outlet>
<app-document-viewer></app-document-viewer>
<app-slide-panel></app-slide-panel>
<app-toaster-container></app-toaster-container>


